import { Component, input } from '@angular/core';
import {
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelDescription,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
} from '@angular/material/expansion';

@Component({
    selector: 'wci-faq',
    imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle],
    templateUrl: './faq.component.html',
    styles: `
        .mat-expansion-panel {
            box-shadow: none !important;
        }

        .mat-expansion-panel-header {
            padding: 0 !important;
        }

        ::ng-deep {
            mat-expansion-panel {
                .mat-expansion-panel-body {
                    padding: 0;
                }
            }
        }

        .mat-expansion-panel-spacing {
            margin: 0 !important;
        }
    `,
})
export class FaqComponent {
    heading = input.required<string>();
    subheader = input<string>();

    items = input.required<{ question: string; answer: string }[]>();
}
